export default function useTourSectionMutations(setSections, formik) {
  function updateSections(nextSectionsOrUpdater, shouldValidate = true) {
    setSections((currentSections) => {
      const nextSections =
        typeof nextSectionsOrUpdater === "function"
          ? nextSectionsOrUpdater(currentSections)
          : nextSectionsOrUpdater;
      formik.setFieldValue("sections", nextSections, shouldValidate);
      return nextSections;
    });
  }

  function updateSection(sectionId, updater) {
    updateSections((currentSections) =>
      currentSections.map((section) =>
        section.id === sectionId ? updater(section) : section,
      ),
    );
  }

  function updateSectionField(sectionId, field, value) {
    updateSection(sectionId, (section) => ({ ...section, [field]: value }));
  }

  function updateSectionLocalizedField(sectionId, field, iso, value) {
    updateSection(sectionId, (section) => ({
      ...section,
      [field]: { ...(section?.[field] || {}), [iso]: value },
    }));
  }

  function updateItem(sectionId, itemId, updater) {
    updateSection(sectionId, (section) => ({
      ...section,
      items: (section.items || []).map((item) =>
        item.id === itemId ? updater(item) : item,
      ),
    }));
  }

  function updateItemField(sectionId, itemId, field, value) {
    updateItem(sectionId, itemId, (item) => ({ ...item, [field]: value }));
  }

  function updateItemLocalizedField(sectionId, itemId, field, iso, value) {
    updateItem(sectionId, itemId, (item) => ({
      ...item,
      [field]: { ...(item?.[field] || {}), [iso]: value },
    }));
  }

  return {
    updateSections,
    updateSection,
    updateSectionField,
    updateSectionLocalizedField,
    updateItem,
    updateItemField,
    updateItemLocalizedField,
  };
}
